import styled from 'styled-components'

import RightArrow from '../../../assets/REDESIGN_Assets/MainScreen/right-arrow.png'
import LeftArrow from '../../../assets/REDESIGN_Assets/MainScreen/left-arrow.png'
import RightFadeIn from '../../../assets/REDESIGN_Assets/MainScreen/right-carousel-fadein.webp'
import LeftFadeIn from '../../../assets/REDESIGN_Assets/MainScreen/left-carousel-fadein.png'
import RightArrowLighttheme from '../../../assets/REDESIGN_Assets/theme/right-arrow-light-theme.svg'
import LeftArrowLightTheme from '../../../assets/REDESIGN_Assets/theme/left-arrow-light-theme.svg'

export const MainPageCarouselBox = styled.div`
  width: 60%;
  margin: 2% auto 0 auto;
  position: relative;

  &.full-width {
    width: 100%;
  }

  @media only screen and (max-width: 600px) {
    width: 100%;
    flex-direction: column;

    @media only screen and (max-width: 600px) {
      width: 90%;
    }
  }

  @media (min-width: 601px) and (max-width: 1280px) {
    width: 90%;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    width: 90%;
  }
`

export const LeftCarouselFadeIn = styled.div`
  height: 100%;
  width: 10%;
  background-image: url(${LeftFadeIn});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: absolute;
`
export const RightCarouselFadeIn = styled.div``

export const UserJoinedBadge = styled.div`
  position: absolute;
  bottom: 20px;
  right: 0;
  z-index: 20;
  border-top-left-radius: 2rem;
  border-bottom-left-radius: 2rem;
  background-color: rgb(161, 255, 104);
  padding: 1rem;
  font-size: 0.75rem;
  font-weight: bold;
  font-family: 'Nunito';
`

export const AlbumCard = styled.div`
  display: flex;
  width: 100%;
  height: 8vh;
  position: relative;
  flex-direction: column;
  padding: 5%;
  min-height: 65px;

  &.diet {
    width: 90%;
  }

  background-image: url(${(props) => (props.src ? props.src : 'unset')});
  border-radius: 19px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.9;

  filter: brightness(0.5);
  cursor: not-allowed;

  @media only screen and (max-width: 600px) {
    border-radius: 19px;
    height: 10vh;
  }

  &.active {
    opacity: 1;
    filter: none;
    cursor: pointer;
  }

  &.album-video {
    width: 88%;
    margin: 3% 3% 3% 0;
  }

  &.next-day-training {
    margin: 3% 3% 3% 3%;
  }
`

export const AlbumName = styled.div`
  font-family: 'Nunito';
  position: relative;
  font-size: 1.5rem;
  /* position: absolute; */
  color: white;
  /* top: 15%;
  left: 10%; */
  font-weight: bold;
  max-width: 80%;

  &.light {
    color: #342152;
  }
`

export const LeftArrowButton = styled.button`
  background-image: url(${LeftArrow});
  border: none;
  left: 10% !important;
  position: absolute;
  background-color: transparent;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 1.5vw;
  height: 1.5vw;
  z-index: 8;

  @media only screen and (max-width: 600px) {
    width: 7.5vw;
    height: 7.5vw;
    left: 10% !important;
  }

  &.light {
    background-image: url(${RightArrowLighttheme});
  }
`

export const RightArrowButton = styled.button`
  background-image: url(${RightArrow});
  background-color: transparent;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border: none;
  width: 1.5vw;
  height: 1.5vw;
  right: 10% !important;
  position: absolute;
  z-index: 8;

  @media only screen and (max-width: 600px) {
    width: 7.5vw;
    height: 7.5vw;
    /* right: -15% !important; */
  }
  &.light {
    background-image: url(${LeftArrowLightTheme});
  }
`

export const MainScreenBanner = styled.div`
  width: 60%;
  display: flex;
  margin: 0 auto;

  @media (max-width: 600px) {
    width: 100%;
    flex-direction: column;
  }

  @media (min-width: 601px) and (max-width: 1280px) {
    width: 90%;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    width: 90%;
  }
`

export const MainPageLinkButton = styled.div`
  font-size: 1.2rem;
  font-family: 'Nunito';
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  /* line-height: 2.21; */
  color: #fff;
  padding: 5px 20px;
  opacity: 0.5;
  border-radius: 19px;
  cursor: pointer;
  border: 1px solid transparent;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3px 5px;

  /* @media only screen and (max-width: 1400px) {
    padding: 0px 5px;
    margin: 3px 5px;
  } */

  @media only screen and (max-width: 600px) {
    padding: 5px 10px;
    margin: 3px 5px;
  }

  &.light {
    color: #342152;
    opacity: 0.7;
    border: 1px solid rgba(0, 0, 0, 0.45);
    background: rgba(0, 0, 0, 0.05);
  }

  &.light.active {
    color: white;
  }

  &:hover {
    background-image: linear-gradient(to right, #728ffc, #ea96b0);
    opacity: 1;
    color: white;
    border: 1px solid transparent;
  }

  &.active {
    background-image: linear-gradient(to right, #728ffc, #ea96b0);
    opacity: 1;
  }
`

export const BannerShopButton = styled.button`
  position: absolute;
  font-family: 'Nunito';
  font-size: 1rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;

  /* letter-spacing: -0.28px; */
  text-align: center;
  color: #611c6a;
  bottom: 20%;
  right: 5%;
  background: none;
  outline: none;
  border: none;
  box-shadow: 2.8px 2.8px 2.2px rgba(0, 0, 0, 0.02),
    6.7px 6.7px 5.3px rgba(0, 0, 0, 0.028),
    12.5px 12.5px 10px rgba(0, 0, 0, 0.035),
    22.3px 22.3px 17.9px rgba(0, 0, 0, 0.042),
    41.8px 41.8px 33.4px rgba(0, 0, 0, 0.05),
    100px 100px 80px rgba(0, 0, 0, 0.07);
  text-align: center;
  padding: 8px 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;

  &.first-banner {
    background-color: white;

    border-radius: 30px;
  }
`

export const BannerDietButton = styled.button`
  font-family: 'Nunito';
  font-size: 0.9rem;
  padding: 8px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;

  /* letter-spacing: -0.28px; */
  text-align: center;
  color: #611c6a;
  box-shadow: 2.8px 2.8px 2.2px rgba(0, 0, 0, 0.02),
    6.7px 6.7px 5.3px rgba(0, 0, 0, 0.028),
    12.5px 12.5px 10px rgba(0, 0, 0, 0.035),
    22.3px 22.3px 17.9px rgba(0, 0, 0, 0.042),
    41.8px 41.8px 33.4px rgba(0, 0, 0, 0.05),
    100px 100px 80px rgba(0, 0, 0, 0.07);
  background-color: #a1ff68;
  border-radius: 19px;
  position: absolute;
  bottom: 20%;
  right: 40%;
  border: none;

  @media only screen and (max-width: 600px) {
    font-size: 0.8rem;
  }
`

export const PaidContentBadge = styled.div`
  position: absolute;
  bottom: 10%;
  right: 5%;
  cursor: pointer;
  font-family: 'Nunito';
  background: #a1ff68;
  font-size: 1.3rem;
  padding: 8px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  box-sizing: border-box;
  border-radius: 19px;
  box-shadow: 2.8px 2.8px 2.2px rgba(0, 0, 0, 0.02),
    6.7px 6.7px 5.3px rgba(0, 0, 0, 0.028),
    12.5px 12.5px 10px rgba(0, 0, 0, 0.035),
    22.3px 22.3px 17.9px rgba(0, 0, 0, 0.042),
    41.8px 41.8px 33.4px rgba(0, 0, 0, 0.05),
    100px 100px 80px rgba(0, 0, 0, 0.07);

  @media only screen and (max-width: 600px) {
    font-size: 1.1rem;
  }
`

export const AlbumCardBox = styled.div`
  display: flex;
  position: relative;
`

export const AlbumVideosCountBox = styled.div``

export const MainScreenPromoBanner = styled.div`
  position: relative;
  background-color: #a1ff68;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 0;
  box-sizing: border-box;
  font-family: 'Nunito';
  font-weight: bold;

  @media (max-width: 768px) {
    flex-direction: column;
  }

  &.landing {
    padding: 0;
  }
`

export const PurchaseChallengeBox = styled.div`
  cursor: pointer;
  width: 100%;
  height: 100%;
  position: absolute;
  /* background-color: rgba(0,0,0,0.45); */
  border-radius: 19px;
  display: flex;

  z-index: 3;
  align-items: flex-end;
  justify-content: flex-end;
`
export const PurchaseChallengeButton = styled.div`
  display: flex;
  margin-right: 3%;
  margin-bottom: 3%;
  z-index: 4;

  border-radius: 30px;
  color: white;
  padding: 3% 4%;
  border: 2px solid #a1ff68;
`
